import Api from "~/api";
import config from "~/config";
import {
    initializeResultSet,
    requestResultSetPage,
    invalidateAllResultSetPages,
} from "~/actions/match-results";
import {INITIAL_MATCH_PROFILE, INITIAL_FILTERS} from "~/reducers/profile-to-jobs";

export const UPDATE_MATCH_PROFILE = "p2jm/UPDATE_MATCH_PROFILE";
export const UPDATE_FILTERS = "p2jm/UPDATE_FILTERS";
export const UPDATE_SORT_MODE = "p2jm/UPDATE_SORT_MODE";
export const SET_DISPLAYED_PAGE = "p2jm/SET_DISPLAYED_PAGE";
export const UPDATE_SELECTION = "p2jm/UPDATE_SELECTION";
export const UPDATE_FIXED_SELECTION = "p2jm/UPDATE_FIXED_SELECTION";
export const UPDATE_MATCHING_STRATEGY = "p2jm/UPDATE_MATCHING_STRATEGY";
export const UPDATE_QUERY = "p2jm/UPDATE_QUERY";
export const SET_LAST_MATCH_REQUEST = "p2jm/SET_LAST_MATCH_REQUEST";

export function initialize() {
    return initializeResultSet(
        "profileToJobs",
        (getState, page, isNewQuery, dispatch) => {
            const matchRequest = getState().profileToJobs.matchRequest;
            const lastMatchRequest = getState().profileToJobs.lastMatchRequest;
            const size = getState().profileToJobs.pageSize;
            const matchingStrategy = getState().profileToJobs.matchingStrategy;
            const from = page * size;
            const language = getState().ui.language;
            const jobIndex = config("features.profileToJobs.jobIndex");
            const sortModeGroup = config("features.profileToJobs.sortModeGroup", undefined);
            const scoreType = config("features.profileToJobs.scoreType", "MUTUAL");
            const expansionType = config("features.profileToJobs.expansionType", "FULL");

            if (isNewQuery) {
                dispatch(setLastMatchRequest(matchRequest));
            }

            return Api.matchProfileToJobs({
                jobIndex,
                matchRequest: isNewQuery ? matchRequest : lastMatchRequest,
                from,
                size,
                language,
                sortModeGroup,
                scoreType,
                expansionType,
                matchingStrategy,
            });
        },
        ({matches, metadata}) => {
            const matchesById = {};
            const ids = [];

            for (const match of matches) {
                matchesById[match.id] = match;
                ids.push(match.id);
            }

            return {
                matches: matchesById,
                ids,
                count: metadata.count,
            };
        }
    );
}

export function updateMatchProfile(matchProfile) {
    return {
        type: UPDATE_MATCH_PROFILE,
        matchProfile,
    };
}

export function updateFilters(filters) {
    return {
        type: UPDATE_FILTERS,
        filters,
    };
}

export function clearMatchProfile() {
    return updateMatchProfile(INITIAL_MATCH_PROFILE);
}

export function clearFilters() {
    return updateFilters(INITIAL_FILTERS);
}

export function setDisplayedPage(displayedPage) {
    return {
        type: SET_DISPLAYED_PAGE,
        displayedPage,
    };
}

export function requestPage(page, isNewQuery = false) {
    return requestResultSetPage("profileToJobs", page, isNewQuery);
}

export function invalidateAllPages() {
    return invalidateAllResultSetPages("profileToJobs");
}

export function updateSortMode(sortMode) {
    return {
        type: UPDATE_SORT_MODE,
        sortMode,
    };
}

export function updateQuery(query) {
    return {
        type: UPDATE_QUERY,
        query,
    };
}

export function updateSelection(selection) {
    return {
        type: UPDATE_SELECTION,
        selection,
    };
}

export function updateFixedSelection(fixedSelection) {
    return {
        type: UPDATE_FIXED_SELECTION,
        fixedSelection,
    };
}

export function clearSelection() {
    return updateSelection({});
}

export function clearFixedSelection() {
    return updateFixedSelection({});
}

export function setLastMatchRequest(matchRequest) {
    return {
        type: SET_LAST_MATCH_REQUEST,
        matchRequest,
    };
}

export function updateMatchingStrategy(matchingStrategy) {
    return {
        type: UPDATE_MATCHING_STRATEGY,
        matchingStrategy,
    };
}

